import script from "./AddSchedule.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddSchedule.vue?vue&type=script&setup=true&lang=ts"

import "./AddSchedule.vue?vue&type=style&index=0&id=3cdf07d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cdf07d1"]])

export default __exports__